export default __webpack_public_path__ + "static/media/stockeer1.357f52a3.png";